import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from 'react'

import CompanyLogo from '../../images/icons/tecxal_logo.png'
import { GroupDataRow, RecipientType, SelectedType, UserDataRow, WarningWorkflowProcessPropsType } from '../earlyWarning/emailComp/EmailTypes'
import SubscribeTable from './SubscribeTable'
import GroupSelectTable from './GroupSelectTable'
import UserSelectTable from './UserSelectTable'
import { CloseIcon, IconDownload, IconTimelineClock, IconTimelineRecipient, SearchIcon } from '../iconSet/IconSet'
import { APICallEarlyWarningRejectRequest, APICallGetAllRecipientRequest, APICallGetAllRecipientRequestExternal, APICallGetPendingRequest, APICallGetWarningInfoByWarningId, APICallGetWarningInfoByWarningIdExternal, APICallWarningAcceptRejectRequest, APICallWarningAcceptRejectRequestExternal, APICallWarningAcceptRequest, APICallWarningAcceptRequestExternal, APIRequestSelectedSubscribersType, APIResponseEarlyWarningRejectTypes, APIResponseGetWarningRequestTypes, APIResponseHistoryRecipientType, APIResponseSelectedSubscribersType, APIResponseWarningType, APIWarningAcceptRequestTypes, APIWarningAcknowledgeRequestTypes, APIWarningRejectRequestTypes, ResponseTypes, APIWarningAcknowledgeRequestInternalTypes, APISaveGroupSubTypes } from '../../services/APIEarlyWarningService'
import TimelineElement from './TimelineElement'
import AlertDialog from '../popupComp/AlertDialog'
import InputGroup from '../inputComp/InputGroup'
import LoadingScreen from '../loadingScreenComp/LoadingScreen'
import { useNavigate } from 'react-router-dom'
import TimelineRecipientElement from './TimelineRecipientElement'
import { useUserData } from '../../context/UserDataContext'
import { APIGetRecipients, APIGetRecipientsExternal, APIRequestGetRecipientBody, APIResponseGetRecipient } from './WorkflowService'

/* const tableDataGroup: GroupDataRow[] = [
    {id: 'id1', departmentName: 'depart 1', name: 'group 1', select: false},
    {id: 'id2', departmentName: 'depart 2', name: 'group 2', select: false},
    {id: 'id3', departmentName: 'depart 3', name: 'group 3', select: false},
    {id: 'id4', departmentName: 'depart 4', name: 'group 4', select: false},
    {id: 'id5', departmentName: 'depart 5', name: 'group 5', select: false},
    {id: 'id6', departmentName: 'depart 6', name: 'group 1', select: false},
    {id: 'id7', departmentName: 'depart 7', name: 'group 2', select: false}
]

const tableDataUser: UserDataRow[] = [
    {id: 'id1', department: 'depart 1', username: 'user 1', sms: false, whatsapp: false, viber: false},
    {id: 'id2', department: 'depart 2', username: 'user 2', sms: false, whatsapp: false, viber: false},
    {id: 'id3', department: 'depart 3', username: 'user 3', sms: false, whatsapp: false, viber: false},
    {id: 'id4', department: 'depart 4', username: 'user 4', sms: false, whatsapp: false, viber: false},
    {id: 'id5', department: 'depart 5', username: 'user 5', sms: false, whatsapp: false, viber: false},
] */

type AddRecipientsRequestType = {
    email: string;
    warningCatCode: string;
}

export type GetSelectedGroup = {
    groupId: string;
    addUser: string;
}

export const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const  WarningWorkflowProcess = (props: WarningWorkflowProcessPropsType) => {

    const { username } = useUserData()

    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const { firstName } = useUserData()

    const [linkUrl, setLinkUrl] = useState<string>('')

    const warningNumberRef = useRef<HTMLInputElement | null>(null)
    const warningDataRef = useRef<HTMLInputElement | null>(null)
    const requestNameRef = useRef<HTMLInputElement | null>(null)
    const requestDepartmentNameRef = useRef<HTMLInputElement | null>(null)
    const phoneRef = useRef<HTMLInputElement | null>(null)
    const reqNameRef = useRef<HTMLInputElement | null>(null)
    const requiredBeforeRef = useRef<HTMLInputElement | null>(null)
    const specialNoteRef = useRef<HTMLInputElement | null>(null)
    const workflowRef = useRef<HTMLInputElement | null>(null)

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };

    const [file, setFile] = useState<string>('')

    const commentRef = useRef<HTMLTextAreaElement | null>(null)
    const messageEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const messageSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const messageDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const messageBengaliRef = useRef<HTMLTextAreaElement | null>(null)

    // Add recipient popup status
    const [addRecipientStatus, setAddRecipientStatus] = useState<boolean>(false)
    const [filteredRecipient, setFilteredRecipient] = useState<RecipientType[]>([])
    const allUsers = useRef<RecipientType[]>([]);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    // Selected recipient
    const [selectedRecipient, setSelectedRecipient] = useState<RecipientType[]>([])

    const finalRecipientRef = useRef<RecipientType[]>([])

    const [status, setStatus] = useState<SelectedType>('ACCEPTED')

    const [warningData, setWarningData] = useState<APIResponseWarningType>()
    const warningDataMainRef = useRef<APIResponseWarningType>()

    const [currentUser, setCurrentUser] = useState<string>('')

    // Selected groups
    const [selectedGroups, setSelectedGroups] = useState<GetSelectedGroup[]>([])
    // Selected user
    const [selectedSubscribers, setSelectedSubscribers] = useState<UserDataRow[]>([])


    const [isCommentPopupOpen, setIsCommentPopupOpen] = useState<boolean>(false);

    const commentBoxRef = useRef<HTMLInputElement | null>(null);

    const [tableData, setTableData] = useState<string>('')

    //const [recipient, setRecipient] = useState<RecipientType[]>([]);
    //const selectedGroups = useRef<GroupDataRow[]>([])
    // Selected users
   // const selectedUsers = useRef<UserDataRow[]>([])

    /* useEffect(() => {
        console.log("USERS: ", selectedUsers)
        console.log("GROUPS: ", selectedGroups)
    }, [selectedUsers, selectedGroups]) */
    // Set data
    /* useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await APICallGetPendingRequest(props.id);

                if (response.httpStatus === 'OK') {
                    setWarningData(response.data[0] as APIResponseGetWarningRequestTypes);
                    console.log("Fetched Warning Data >>>", response.data);
                } else {
                    console.warn("Unexpected response:", response);
                }
            } catch (err: any) {
                console.error("Failed to fetch warning data:", err);
            }
        };

        fetchData();
    }, [props.id]) */

    const getAllUsers = () => {
        const token = props.token || localStorage.getItem("access_token") || "";

        if (props.type === 'INTERNAL'){
            fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                allUsers.current = data;
                //console.log("-------85: ", allUsers.current)
                setFilteredRecipient(data === undefined ? [] : data);
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
        else {
            fetch(BASE_URL + `/jwt-auth/api/v1/getallusers?token=${props.token}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                allUsers.current = data;
                //console.log("-------85: ", allUsers.current)
                setFilteredRecipient(data);
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
        
    };

    // Get selected groups
    const getAllSelectedGroups = () => {
        const token = props.token || localStorage.getItem("access_token") || "";
        if (props.type === 'INTERNAL'){
            fetch(`${BASE_URL}/ew/api/v1/getSelectedGroups?warningCatCode=${warningData?.workflow}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> data: ", data)
                setSelectedGroups(response.data as GetSelectedGroup[])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
        else {
            
            fetch(`${BASE_URL}/jwt-auth/api/v1/getSelectedGroups?token=${props.token}&warningCatCode=${warningData?.workflow}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> data: ", data)
                setSelectedGroups(response.data as GetSelectedGroup[])
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
    };

    // Get selected groups
    const getAllSelectedSubscribers = () => {
        const token = props.token || localStorage.getItem("access_token") || "";
        if (props.type === 'INTERNAL'){
            fetch(`${BASE_URL}/ew/api/v1/getSelectedSubscribers?warningCatCode=${warningData?.workflow}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> subs: ", response.data)

                setSelectedSubscribers(setSubscribersFromApi(response.data as APIResponseSelectedSubscribersType[]))
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
        else {
            fetch(`${BASE_URL}/jwt-auth/api/v1/getSelectedSubscribers?token=${props.token}&warningCatCode=${warningData?.workflow}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
                //console.log(">>>>>>> subs: ", response.data)

                setSelectedSubscribers(setSubscribersFromApi(response.data as APIResponseSelectedSubscribersType[]))
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
    };

    // const getRecipients = async () => {
    //     const token = props.token || localStorage.getItem("access_token") || "";
    //     let response
    //     if (warningData){

    //         if (props.type === 'INTERNAL'){
    //             response = await APICallGetAllRecipientRequest(warningData.workflow, token)
    //         } else {
    //             response = await APICallGetAllRecipientRequestExternal(token, warningData.workflow)
    //         }
            
    //         const responseUsernames = response.map((r: { username: string }) => r.username);
    //         const matchedRecipients = allUsers.current.filter(user => responseUsernames.includes(user.email))
    //         finalRecipientRef.current = matchedRecipients
    //         setSelectedRecipient(matchedRecipients)
    //     }
    // }

    const [recipients, setRecipients] = useState<APIResponseGetRecipient[]>([])
    const [recipientIds, setRecipientId] = useState<string[]>([])

    const getRecipients = async () => {

        if (!warningData) return

        const requestBody: APIRequestGetRecipientBody = {
            warningId: warningData.warningNumber,
            workflowId: warningData.warningId
        }

        let recipient = null
        if (props.type === 'INTERNAL')
        {
            recipient = await APIGetRecipients(requestBody)
        }
        else 
        {
            recipient = await APIGetRecipientsExternal(requestBody, props.token!)
        }
        
        
        if (recipient.status)
        {
            setRecipients(recipient.data as APIResponseGetRecipient[])
            
        }
        else 
        {
            console.error(recipient.message)
        }
    }

    useEffect(() => {
        recipients.map(item => (
            setRecipientId(prevState => [...prevState, item.email])
        ))
    }, [recipients])

    useEffect(() => {
        recipientIds.map(item => {
            const value = allUsers.current.find(a => a.email === item)

            if (value)
            {
                setSelectedRecipient(prevState => [...prevState, value])
            }
        })
                
    }, [recipientIds])

    const fetchData = async () => {
        setIsLoading(true)
        const token = props.token || localStorage.getItem("access_token")
        try {
            let response;
            //console.log("<<<<<<<<<<<<<<<<< ", props.catMType)
            if(props.type === 'INTERNAL'){
                response = await APICallGetWarningInfoByWarningId(props.id, props.catMType, token!)
                //console.log(">>>>>>>>>> INTERNAL: ", response)
            } else {
                response = await APICallGetWarningInfoByWarningIdExternal(props.catMType, token!)
                //console.log(">>>>>>>>>> EXTERNAL: ", response)
            }
            
            if (response.httpStatus === 'OK') {

                const data = response.data as APIResponseWarningType
                //console.log(">>>>>>>>>> DATA: ", data)
                // sort by performedDate descending (newest first)
                data.history.sort(
                    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
                )
                setWarningData(response.data as APIResponseWarningType);
                warningDataMainRef.current = response.data as APIResponseWarningType
                
            } else {
                //console.warn("Unexpected response:", response);
            }
        } catch (err: any) {
            console.error("Failed to fetch warning data:", err);
            navigate('/login')
        }
        setIsLoading(false)
    };

    useEffect(() => {
        fetchData()
    }, [props.id])

    useEffect(() => {
        
        if (!warningData) return;
        
        const warning = warningData;

        //console.log("Populating fields with >>>", warning);
        
        const str = warning.reportLink
        const hasAfterThirdSlash = str.split("/")[3] ? true : false;
        setLinkUrl(hasAfterThirdSlash ? warning.reportLink : '')
        setTableData(warning.tableData)
        setData(warningNumberRef, warning.warningNumber || 'N/A');
        //setData(commentRef, warning?.comments || 'N/A')
        setData(warningDataRef, formatTimestamp(warning?.warningDate) || 'N/A');
        setData(requestNameRef, warning.requestName || 'N/A');
        setData(requestDepartmentNameRef, warning.requestersDepartment || 'N/A');
        setData(phoneRef, warning.contactNumber || 'N/A');
        setData(reqNameRef, warning.requestName || 'N/A');
        setData(requiredBeforeRef, warning.preRequestDocument || 'N/A');
        setData(specialNoteRef, 'N/A');
        setData(workflowRef, warning.workflow || 'N/A');

        //setFile(warning.supportiveDocument ?? '');

        setData(commentRef, warning.comment || 'N/A');
        setData(messageEnglishRef, warning.messageBodyEnglish || 'N/A');
        setData(messageSinhalaRef, warning.messageBodySinhala || 'N/A');
        setData(messageDhivehiRef, warning.messageBodyDhivehi || 'N/A');
        setData(messageBengaliRef, warning.messageBodyBengali || 'N/A');
        //console.log("KKKKKKKKKKK -> ", warning)
    }, [warningData])

    // Set data to ref
    const setData = (ref: MutableRefObject<HTMLInputElement | HTMLTextAreaElement | null>, data: string) => {
        if(ref.current) {
            ref.current.value = data
        }
    }

    const getRecipientId = (): string[] => {
        let result: string[] = []

        if (finalRecipientRef.current){
            finalRecipientRef.current.map((item) => {
                result.push(item.email)
            })
        }
        

        return result
    }

    /* const getGroupId = (): string[] => {
        let result: string[] = []

        selectedGroups.map((item) => {
            result.push(item.groupid)
        })

        return result
    } */

    const getSubscribersId = (): APIRequestSelectedSubscribersType[] => {
        let result: APIRequestSelectedSubscribersType[] = []

        selectedSubscribers.map((item) => {
            const newSubscriber: APIRequestSelectedSubscribersType = {
                userId: item.id,
                sms: item.sms,
                whatsapp: item.whatsapp,
                viber: item.viber
            }
            result.push(newSubscriber)
        })

        return result
    }

    useEffect(() => {
        getRecipients()
        //console.log(">>>>>>>>>>> SELECTED SUBS: ", selectedSubscribers)
    }, [selectedSubscribers])

    const setSubscribersFromApi = (apiSubscribers: APIResponseSelectedSubscribersType[]): UserDataRow[] => {
        return apiSubscribers.map((item) => ({
            isEditable: item.addUser === username ? true : false,
            id: item.id.userId,
            firstName: '',
            lastName: '',
            email: '',
            sms: item.sms,
            whatsapp: item.whatsapp,
            viber: item.viber
        }))
    }

    const getGroupIdList = (groups: GetSelectedGroup[])  => {
        const data: string[] = []
        groups.map(item => (
            data.push(item.groupId)
        ))
        return data
    }

    // Handle accept button click
    const handleAcceptButtonClick = async () => {
        setIsLoading(true)
        const token = props.token || localStorage.getItem("access_token") || "";
        //console.log(">>>>>>>>>>> ", warningData)
        if (warningData && commentBoxRef.current)
        {
            const body: APIWarningAcceptRequestTypes = {
                warningId: warningData.warningNumber,
                warningCatType: warningData.workflow,
                recipients: getRecipientId(),
                selectedGroups: getGroupIdList(selectedGroups),
                selectedSubscribers: getSubscribersId(),
                warningCatMType: warningData.catMType,
                comment: commentBoxRef.current.value
            }
            //console.log(">>>>>>>>>>>>>>>>>>> RECIPIENT: ", body)
            let response
            if (props.type === 'EXTERNAL'){
                response = await APICallWarningAcceptRequestExternal(body, props.token!)
            } else {
                response = await APICallWarningAcceptRequest(body, token)
            }
            

            if (!response.errorCode)
            {
                console.log("✅ approving successfully");
                
               //showAlertDialog("Success", "✅ Approving successfully!");
               showAlertDialog("Success", "✅ Approving successfully!", undefined, () => window.location.reload());
                
            } 
            else 
            {
                switch (response.errorCode) {
                    case 1010:
                        console.log("❌ ", response.errorMessage);
                        showAlertDialog("Unauthorized", "❌ Unauthorized request");
                        break
                    default:
                        console.log("❌ ", response.errorMessage);
                        showAlertDialog("Error", "❌ Error adding data");
                }
                
            }
        }
        setIsLoading(false)
    }

    // Handle reject button click
    const handleRejectButtonClick = async () => {
        setIsLoading(true)
        const token = props.token || localStorage.getItem("access_token") || "";
        if (warningData)
        {
            const body: APIWarningRejectRequestTypes = {
                warningId: warningData.warningNumber,
                warningType: warningData.workflow
            }
            //console.log("REJECT: ", body)
            let response
            if (props.type === 'INTERNAL'){
                response = await APICallWarningAcceptRejectRequest(body, token)
            } else {
                response = await APICallWarningAcceptRejectRequestExternal(body, props.token!)
            }
            

            if (!response.errorCode)
            {
                console.log("✅ rejected successfully");
                
                //showAlertDialog("Success", "✅ Rejected successfully!");
                showAlertDialog("Success", "✅ Rejected successfully!", undefined, () => window.location.reload());
            } 
            else 
            {
                switch (response.errorCode) {
                    case 1010:
                        console.log("❌ ", response.errorMessage);
                        showAlertDialog("Unauthorized", "❌ Unauthorized request");
                        break
                    default:
                        console.log("❌ ", response.errorMessage);
                        showAlertDialog("Error", "❌ Error adding data");
                }
                
            }
        }
        setIsLoading(false)
    }

    // Handle Search recipient
    const handleRecipientChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const query = event.target.value.toLowerCase();
        if (query === '') {
            setFilteredRecipient(allUsers.current);
        } else {
            setFilteredRecipient(
                allUsers.current.filter(item => item.email.toLowerCase().includes(query))
            );
        }
    }

    // Handle checking recipients
    const handleSelectRecipient = (event: ChangeEvent<HTMLInputElement>, data: RecipientType) => {
        if (event.target.checked) {
            setSelectedRecipient(prevState => [...prevState, data])
        } else {
            setSelectedRecipient(prevState => prevState.filter(item => item.email !== event.target.name))
        }
    }
    
    // const checkSelectedOrNot = (name: string): boolean => {
    //     const exists = finalRecipientRef.current.some(recipientNames => recipientNames.email === name)
    //     return exists
    // }

    useEffect(() => {
        getAllUsers()
        getRecipients()
        getAllSelectedGroups()
        getAllSelectedSubscribers()
        //fetchData()
    }, [warningData])

    /* useEffect(() => {
        console.log("Selected Recipient", selectedRecipient)
    }, [selectedRecipient]) */

    const handleAcknowledgeButtonClick = () => {
        setIsLoading(true)
        if (warningData)
        {
            const body: APIWarningAcknowledgeRequestTypes = {
                selectedGroups: getGroupIdList(selectedGroups),
                selectedSubscribers: getSubscribersId(),
            }

            fetch(`${BASE_URL}/jwt-auth/api/v1/acknowledge?token=${props.token}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body)
            })
            .then((res) => res.json())
            .then((data) => {
                const response = data as ResponseTypes
    
                if (response.httpStatus === 'OK'){
                    window.location.reload()
                }
            })
            .catch((err) => console.error("Error fetching roles:", err));
        }
        setIsLoading(false)
    }

    const reloadPage = () => {
        //window.location.reload()
    }

    const handleSendMessagesButtonClick = () => {
        setIsLoading(true)
        if (warningData)
        {
            if (props.type === "INTERNAL")
            {
                const token = localStorage.getItem("access_token");
                if (!token) {
                    throw new Error("Missing access token");
                }

                if (warningNumberRef.current){
                    const body: APIWarningAcknowledgeRequestInternalTypes = {
                        selectedGroups: getGroupIdList(selectedGroups),
                        selectedSubscribers: getSubscribersId(),
                        warningId: warningNumberRef.current.value
                    }
        
                    fetch(`${BASE_URL}/ew/api/v1/acknowledge_disse_send?token`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify(body)
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        const response = data as ResponseTypes
            
                        if (response.httpStatus === 'OK'){
                            setIsLoading(false)
                            showAlertDialog("Success", "✅ Dissemination message send successfully", undefined, () => reloadPage());
                        }
                    })
                    .catch((err) => {
                        setIsLoading(false)
                        console.error("Error fetching roles:", err)
                        showAlertDialog("Error", "❌ Dissemination message sending failed", undefined, () => reloadPage())
                    })
                    .finally(() => {
                        setIsLoading(false)
                    })
                }
            }
            else if (props.type === "EXTERNAL" || props.type === "ACK")
            {
                const body: APIWarningAcknowledgeRequestTypes = {
                    selectedGroups: getGroupIdList(selectedGroups),
                    selectedSubscribers: getSubscribersId(),
                }
    
                fetch(`${BASE_URL}/jwt-auth/api/v1/acknowledge_disse_send?token=${props.token}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body)
                })
                .then((res) => res.json())
                .then((data) => {
                    const response = data as ResponseTypes
        
                    if (response.httpStatus === 'OK'){
                        setIsLoading(false)
                        showAlertDialog("Success", "✅ Dissemination message send successfully", undefined, () => reloadPage());
                    }
                })
                .catch((err) => {
                    setIsLoading(false)
                    console.error("Error fetching roles:", err)
                    showAlertDialog("Error", "❌ Dissemination message sending failed", undefined, () => reloadPage())
                })
                .finally(() => {
                    setIsLoading(false)
                })
            }
        }
    }

    const handleSaveSubscribersAndGroupButtonClick = () => {
        setIsLoading(true)
        if (warningData)
        {
            // if (props.type === "INTERNAL")
            // {
                
            // }
            // else if (props.type === "EXTERNAL" || props.type === "ACK")
            // {
            //     const body: APIWarningAcknowledgeRequestTypes = {
            //         selectedGroups: selectedGroups,
            //         selectedSubscribers: getSubscribersId(),
            //     }
    
            //     fetch(`${BASE_URL}/jwt-auth/api/v1/acknowledge_disse_send?token=${props.token}`, {
            //         method: "POST",
            //         headers: {
            //             "Content-Type": "application/json",
            //         },
            //         body: JSON.stringify(body)
            //     })
            //     .then((res) => res.json())
            //     .then((data) => {
            //         const response = data as ResponseTypes
        
            //         if (response.httpStatus === 'OK'){
            //             setIsLoading(false)
            //             showAlertDialog("Success", "✅ Dissemination message send successfully", undefined, () => reloadPage());
            //         }
            //     })
            //     .catch((err) => {
            //         setIsLoading(false)
            //         console.error("Error fetching roles:", err)
            //         showAlertDialog("Error", "❌ Dissemination message sending failed", undefined, () => reloadPage())
            //     })
            //     .finally(() => {
            //         setIsLoading(false)
            //     })
            // }
            const token = localStorage.getItem("access_token");
                if (!token) {
                    throw new Error("Missing access token");
                }

                if (warningNumberRef.current && workflowRef.current){
                    const body: APISaveGroupSubTypes = {
                        selectedGroups: getGroupIdList(selectedGroups),
                        selectedSubscribers: getSubscribersId(),
                        warningId: warningNumberRef.current.value,
                        workflowId: workflowRef.current.value

                    }
        
                    fetch(`${BASE_URL}/ew/api/v1/saveGroupAndSubscribers`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        },
                        body: JSON.stringify(body)
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        const response = data as ResponseTypes
            
                        if (response.httpStatus === 'OK'){
                            setIsLoading(false)
                            showAlertDialog("Success", "✅ Groups and subscribers saved successfully", undefined, () => reloadPage());
                        }
                    })
                    .catch((err) => {
                        setIsLoading(false)
                        console.error("Error fetching roles:", err)
                        showAlertDialog("Error", "❌ Groups and subscribers saving failed", undefined, () => reloadPage())
                    })
                    .finally(() => {
                        setIsLoading(false)
                    })
                }
        }
    }

    const handleClickRecipientSetButton = () => {
        setIsLoading(true)
        if (selectedRecipient.length > 0) {
            finalRecipientRef.current = selectedRecipient

            const recipientsList: AddRecipientsRequestType[] = []

            finalRecipientRef.current.map((item, index) => {
                const data: AddRecipientsRequestType = {
                    email: item.email,
                    warningCatCode: warningData?.workflow!
                }
                recipientsList.push(data)
            })
            

            if (props.type === 'INTERNAL') {
                const token = localStorage.getItem("access_token")
                console.log("Id: ", warningData)
                fetch(`${BASE_URL}/ew/api/v1/add_recipients?procId=${warningData?.warningNumber}`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(recipientsList)
                })
                .then(res => res.json())
                .then((data) => {
                    const response = data as ResponseTypes
                    if (response.httpStatus === 'OK'){
                        fetchData()
                        setAddRecipientStatus(false)
                    }
                })
                .finally(() => setAddRecipientStatus(false))
            }
            else {
                fetch(`${BASE_URL}/jwt-auth/api/v1/add_recipients?token=${props.token}&procId=${warningData?.warningNumber}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(recipientsList)
                })
                .then(res => res.json())
                .then((data) => {
                    const response = data as ResponseTypes
                    if (response.httpStatus === 'OK'){
                        fetchData()
                        setAddRecipientStatus(false)
                    }
                })
                .finally(() => setAddRecipientStatus(false))
            }

            //console.log("RECIPIENT: -> ", warningData?.warningNumber)
            //fetchData()
            //setIsLoading(false)
            //setAddRecipientStatus(false)
        } else
        {
            finalRecipientRef.current = []
            setIsLoading(false)
            //setAddRecipientStatus(false)
        }
    }

    useEffect(() => {
        if (props.type === 'INTERNAL')
        {
            // const savedUser = sessionStorage.getItem("userdetails")
            // if (!savedUser) {
            //     throw new Error("No user in sessionStorage")
            // }

            // const parsedUser = JSON.parse(savedUser);
            // setCurrentUser(parsedUser.firstname)
            //console.log(">>>>>>>>>> ", parsedUser.firstname)
            setCurrentUser(firstName)
        }
        else {
            setCurrentUser(props.currentUser || '')
        }
    }, [])

    const downloadHandle = () => {
        
        if(linkUrl){
            const fullUrl = `${BASE_URL}/static_resource/api/v1/files${linkUrl}`
            console.log("URL: ", fullUrl)

            /* const link = document.createElement("a")
            link.href = fullUrl;
            link.setAttribute("download", linkUrl)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) */
            window.open(fullUrl, "_blank")
        }
    }

    useEffect(() => {
        //console.log("WARNING DATA -> ", warningData)
        //console.log("WARNING TYPE -> ", props.currentUser)
        //console.log("ACK -> ", props.type)
    }, [warningData])

    return (
        <div className='warning-workflow-process'>
            {/* <header>
                <img src={CompanyLogo} alt="tecxal logo"/>
                <span className='username'>{props.username}</span>
            </header> */}
            <div className='title-wrapper'>
                <div className='left-side'>
                    <span className='main-title'>early warning management system</span>
                    {/* <span className='sub-title'>tecxal systems</span> */}
                </div>
                {warningData && warningData.status === 'ACCEPTED' && (
                    <div className='right-side'>
                        <span style={{backgroundColor: 'var(--color-button-green-bg)'}}>approved</span>
                    </div>
                )}
                {warningData && warningData.status === 'REJECTED' && (
                    <div className='right-side'>
                        <span style={{backgroundColor: 'var(--color-button-red-bg)'}}>rejected</span>
                    </div>
                )}
                {(warningData && warningData.status === 'PENDING' || warningData && warningData.status === 'RECIPIENT') && (
                    <div className='right-side'>
                        {props.type === 'ACK' && (
                            <span style={{backgroundColor: 'var(--color-button-green-bg)'}} onClick={(e) => 
                                    showAlertDialog(
                                        "Accept Early Warning",
                                        "Are you sure you want to acknowledge this early warning?",
                                        handleAcknowledgeButtonClick, undefined) 
                                    //handleAcceptButtonClick()
                                }>Acknowledge</span>
                        )}
                        {props.type === 'EXTERNAL' && (
                            <>
                                <span style={{backgroundColor: 'var(--color-button-green-bg)'}} onClick={(e) => setIsCommentPopupOpen(true)
                                }>accept</span>
                                <span style={{backgroundColor: 'var(--color-button-red-bg)'}} onClick={(e) => 
                                    showAlertDialog(
                                            "Reject Early Warning",
                                            "Are you sure you want to reject this early warning?",
                                            handleRejectButtonClick, undefined) 
                                        //handleRejectButtonClick()
                                }>reject</span>
                                <span style={{backgroundColor: 'var(--color-button-blue-bg)'}} onClick={(e) => setAddRecipientStatus(prevState => !prevState)}>add recipient</span>
                            </>
                        )}
                        {props.type === 'INTERNAL' && (
                            <>
                                <span style={{backgroundColor: 'var(--color-button-green-bg)'}} onClick={(e) => setIsCommentPopupOpen(true)}>accept</span>
                                <span style={{backgroundColor: 'var(--color-button-red-bg)'}} onClick={(e) => 
                                    showAlertDialog(
                                            "Reject Early Warning",
                                            "Are you sure you want to reject this early warning?",
                                            handleRejectButtonClick, undefined) 
                                        //handleRejectButtonClick()
                                }>reject</span>
                                <span style={{backgroundColor: 'var(--color-button-blue-bg)'}} onClick={(e) => setAddRecipientStatus(prevState => !prevState)}>add recipient</span>
                            </>
                            
                        )}
                        
                    </div>
                )}
                {warningData && (warningData.status === 'FINALIZE') && (
                    <div className='right-side'>
                        {props.type === 'ACK' && (
                            <span style={{backgroundColor: 'var(--color-button-green-bg)'}} onClick={(e) => 
                                    showAlertDialog(
                                        "Accept Early Warning",
                                        "Are you sure you want to accept this early warning?",
                                        handleAcknowledgeButtonClick) 
                                    //handleAcceptButtonClick()
                                }>Acknowledge</span>
                        )}
                    </div>
                )}
                
            </div>

            <div className='paper-wrapper'>
                <header>
                    <span>{currentUser}</span>
                    {/* <span>{props.pageDate}</span> */}
                </header>
                <div className='main-title'>
                    <span>Warning Workflow Process</span>
                </div>
                <div className='form-wrapper'>
                    <div className='field-box'>
                        <span>Warning Number</span>
                        <input type="text" ref={warningNumberRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Warning Date</span>
                        <input type="text" ref={warningDataRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Requester Name</span>
                        <input type="text" ref={requestNameRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Requester's Department</span>
                        <input type="text" ref={requestDepartmentNameRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Phone</span>
                        <input type="text" ref={phoneRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Req Name:</span>
                        <input type="text" ref={reqNameRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Required Before</span>
                        <input type="text" ref={requiredBeforeRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Special Note</span>
                        <input type="text" ref={specialNoteRef} disabled={true}/>
                    </div>
                    <div className='field-box'>
                        <span>Workflow</span>
                        <input type="text" ref={workflowRef} disabled={true}/>
                    </div>
                </div>
                <div className='timeline-wrapper'>
                    <span className='date-tag'>{warningData?.history?.[0]?.performedDate ? formatTimestamp(warningData.history[0].performedDate) : 'No history'}</span>
                    <div className='left' style={{height: '2rem'}}></div>
                    <div className='right' style={{backgroundColor: 'transparent'}}></div>

                    {/* Time */}
                    {Array.isArray(warningData?.history) && warningData.history.map((notification: any, index: number) => (
                        <React.Fragment key={index}>
                            {notification.status !== 'RECIPIENT' && <TimelineElement data={notification} warning={warningData} />}
                            {notification.status !== 'SYSTEM' && (
                                notification.recipients.length > 0 && (
                                    notification.recipients.map((res: APIResponseHistoryRecipientType, idx: number) => (
                                        <TimelineRecipientElement key={idx} data={res} warningCatId={warningData.catMType} performedBy={notification.performedUser} warningNumber={warningData.warningNumber} warningName='warning name' performedData={notification.performedDate} index={idx} length={notification.recipients.length}/>
                                    ))
                                )
                            )}
                            
                        </React.Fragment>
                    ))}

                </div>
                <div className='report-information-wrapper'>
                    <div className='title'>
                        <span>Warning Information</span>
                    </div>
                    <div style={{ width: '100%', borderStyle: 'dashed', borderWidth: '0 0 0.1rem 0', borderColor: 'var(--color-text)'}}>
                        {tableData != '' && (
                            <div dangerouslySetInnerHTML={{ __html: tableData }} />
                        )}
                    </div>
                    <div className='attachment-wrapper'>
                        <span>Attachment</span>
                        <div className='file-box'>
                            <span className='title'>File name</span>
                            {/* <input type="text" ref={fileNameRef} disabled={true}/> */}
                            {linkUrl === "" || linkUrl === undefined ? (
                                <span className='empty-list'>No any file available</span>
                            ) : (
                                <div className='image-icon-wrapper' onClick={(e) => downloadHandle()}>
                                    {/* {file.map((file, index) => (
                                        <span className='download-file' key={index} >{file} <IconDownload width='1rem' color='var(--color-main-white)'/></span>
                                    ))} */}
                                    <span className='download-file' >Document<IconDownload width='1rem' color='var(--color-main-white)'/></span>
                                </div>
                                
                            )}
                        </div>
                    </div>
                    <div className='comment-wrapper'>
                        <div className='field-box'>
                            <span>comments</span>
                            <textarea ref={commentRef} disabled={true}/>
                        </div>
                        <div className='field-box'>
                            <span>Message content- English</span>
                            <textarea ref={messageEnglishRef} disabled={true}/>
                        </div>
                        <div className='field-box'>
                            <span>Message content- Bengali</span>
                            <textarea ref={messageBengaliRef} disabled={true}/>
                        </div>
                        <div className='field-box'>
                            <span>Message content- Dhivehi</span>
                            <textarea ref={messageDhivehiRef} disabled={true}/>
                        </div>
                    </div>
                </div>

                {/* <div className='subscribe-data-table-wrapper'>
                    <div className='title'>
                        <span>Subscriber Details(SMS & Whatsapp)</span>
                    </div>
                    <SubscribeTable tableData={props.subscribeList}/>
                </div> */}
                <div className='subscribe-data-table-wrapper'>
                    <>
                        <div className='title'>
                            <span>Select subscribers and subscriber groups</span>
                        </div>
                        <div className='table-set-wrapper' style={{marginTop: "1rem"}}>
                            <GroupSelectTable selectedGroup={selectedGroups} setSelectedGroup={setSelectedGroups} type={props.type} token={props.token}/>
                            <UserSelectTable  userSelect={selectedSubscribers} setUserSelect={setSelectedSubscribers} type={props.type} token={props.token}/>
                        </div>
                        <div className="button-container">
                            {warningData?.currentStatus === "approved" ? (
                                <button onClick={(e) => {
                                    showAlertDialog(
                                        "Send dissemination messages",
                                        "Are you sure you want to send dissemination messages to selected users?",
                                        handleSendMessagesButtonClick, undefined
                                    ) 
                                }}>Send messages</button>
                            ) : (
                                <button onClick={(e) => {
                                    showAlertDialog(
                                        "Send dissemination messages",
                                        "Are you sure you want to save selected subscribers and groups?",
                                        handleSaveSubscribersAndGroupButtonClick, undefined
                                    ) 
                                }}>Save subscribers and Groups</button>
                            )}
                        </div>
                    </>
                   
                    {/* {props.type === 'EXTERNAL' && (
                        <>
                            <div className='title'>
                                <span>select group and users</span>
                            </div>
                            <div className='table-set-wrapper'>
                                <GroupSelectTable selectedGroup={selectedGroups} setSelectedGroup={setSelectedGroups}/>
                                <UserSelectTable  userSelect={selectedSubscribers} setUserSelect={setSelectedSubscribers}/>
                            </div>
                        </>
                    )} */}
                </div>
            </div>
            {addRecipientStatus && (
                <div className='add-recipient-popup-wrapper'>
                    <div className='data-wrapper'>
                        <div className='header'>
                            <span className='title'>Select recipient</span>
                            <div onClick={(e) =>{ 
                                setAddRecipientStatus(false)
                                handleRecipientChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);}} style={{cursor: 'pointer'}}>
                                <CloseIcon width='1rem' color='var(--color-text)'/>
                            </div>
                        </div>
                        
                        <div className='upper-wrapper'>
                            <InputGroup type='text' icon={<SearchIcon width="1.5rem" color="var(--color-main-white)" />} placeholder='Search here' color='var(--color-accent-bg)' name='telephone' onChange={(e) => handleRecipientChange(e)}/>
                            
                        </div>
                        <div className='data-row-wrapper'>
                            {filteredRecipient!.map((item, index) => (
                                <div key={index} className='data-row'>
                                    <div>
                                        <input type="checkbox" name={item.email} onChange={(e) => handleSelectRecipient(e, item)} defaultChecked={recipientIds.includes(item.email)}/>
                                    </div>
                                    <div className='name'>
                                        <span>{item.firstname}</span>
                                    </div>
                                    <div className='depart'>
                                        <span>{item.department}</span>
                                    </div>
                                    <div className='depart'>
                                        <span>{item.role}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='bottom-wrapper'>
                            <div className={`button-wrapper`} style={{ gridArea: "button" }}>
                            <div className={`left-side`}></div>
                            <div className={`right-side`}>
                                <button className={`button-normal`} onClick={() => handleClickRecipientSetButton()}>Save</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoadingScreen />
            )}
            {alertDialogState && (
                <AlertDialog
                    title={alertTitle}
                    description={alertDescription}
                    windowState={alertDialogState}
                    setWindowState={setAlertDialogState}
                    function={alertYesCallback}
                    okFunction={alertOkCallback}
                />
            )}

            {isCommentPopupOpen && (
                <div className='comment-popup-wrapper'>
                    <div className='popup-wrapper'>
                        <div className='title-wrapper'>
                            <span className='title'>Early Warning Comment</span>
                            <div className='icon' onClick={(e) => setIsCommentPopupOpen(false)}>
                                <CloseIcon width='1rem' color='var(--color-main-red)'/>
                            </div>
                        </div>
                        
                        <div className='popup-body'>
                            <span>Enter any comment if available</span>
                            <input type="text" placeholder='Enter comment here' ref={commentBoxRef} />
                            <div className='button-wrapper'>
                                <button onClick={(e) => {
                                    showAlertDialog(
                                        "Accept Early Warning",
                                        "Are you sure you want to accept this early warning?",
                                        handleAcceptButtonClick, undefined) 
                                }}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default WarningWorkflowProcess

